import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentShiftForMechanicQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentShiftForMechanicQuery = { __typename?: 'Query', getCurrentShift?: { __typename?: 'Shift', id: string, startTime: any, endTime?: any | null } | null };

export type StartShiftForEmployeeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type StartShiftForEmployeeMutation = { __typename?: 'Mutation', employeeStartShift: { __typename?: 'Shift', id: string, startTime: any } };

export type EndShiftForEmployeeMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type EndShiftForEmployeeMutation = { __typename?: 'Mutation', employeeEndShift: { __typename?: 'Shift', id: string, startTime: any } };


export const GetCurrentShiftForMechanicDocument = gql`
    query GetCurrentShiftForMechanic {
  getCurrentShift {
    id
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCurrentShiftForMechanicQuery__
 *
 * To run a query within a React component, call `useGetCurrentShiftForMechanicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentShiftForMechanicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentShiftForMechanicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentShiftForMechanicQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>(GetCurrentShiftForMechanicDocument, options);
      }
export function useGetCurrentShiftForMechanicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>(GetCurrentShiftForMechanicDocument, options);
        }
export function useGetCurrentShiftForMechanicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>(GetCurrentShiftForMechanicDocument, options);
        }
export type GetCurrentShiftForMechanicQueryHookResult = ReturnType<typeof useGetCurrentShiftForMechanicQuery>;
export type GetCurrentShiftForMechanicLazyQueryHookResult = ReturnType<typeof useGetCurrentShiftForMechanicLazyQuery>;
export type GetCurrentShiftForMechanicSuspenseQueryHookResult = ReturnType<typeof useGetCurrentShiftForMechanicSuspenseQuery>;
export type GetCurrentShiftForMechanicQueryResult = Apollo.QueryResult<GetCurrentShiftForMechanicQuery, GetCurrentShiftForMechanicQueryVariables>;
export const StartShiftForEmployeeDocument = gql`
    mutation StartShiftForEmployee {
  employeeStartShift {
    id
    startTime
  }
}
    `;
export type StartShiftForEmployeeMutationFn = Apollo.MutationFunction<StartShiftForEmployeeMutation, StartShiftForEmployeeMutationVariables>;

/**
 * __useStartShiftForEmployeeMutation__
 *
 * To run a mutation, you first call `useStartShiftForEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartShiftForEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startShiftForEmployeeMutation, { data, loading, error }] = useStartShiftForEmployeeMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartShiftForEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<StartShiftForEmployeeMutation, StartShiftForEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartShiftForEmployeeMutation, StartShiftForEmployeeMutationVariables>(StartShiftForEmployeeDocument, options);
      }
export type StartShiftForEmployeeMutationHookResult = ReturnType<typeof useStartShiftForEmployeeMutation>;
export type StartShiftForEmployeeMutationResult = Apollo.MutationResult<StartShiftForEmployeeMutation>;
export type StartShiftForEmployeeMutationOptions = Apollo.BaseMutationOptions<StartShiftForEmployeeMutation, StartShiftForEmployeeMutationVariables>;
export const EndShiftForEmployeeDocument = gql`
    mutation EndShiftForEmployee {
  employeeEndShift {
    id
    startTime
  }
}
    `;
export type EndShiftForEmployeeMutationFn = Apollo.MutationFunction<EndShiftForEmployeeMutation, EndShiftForEmployeeMutationVariables>;

/**
 * __useEndShiftForEmployeeMutation__
 *
 * To run a mutation, you first call `useEndShiftForEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndShiftForEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endShiftForEmployeeMutation, { data, loading, error }] = useEndShiftForEmployeeMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndShiftForEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<EndShiftForEmployeeMutation, EndShiftForEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndShiftForEmployeeMutation, EndShiftForEmployeeMutationVariables>(EndShiftForEmployeeDocument, options);
      }
export type EndShiftForEmployeeMutationHookResult = ReturnType<typeof useEndShiftForEmployeeMutation>;
export type EndShiftForEmployeeMutationResult = Apollo.MutationResult<EndShiftForEmployeeMutation>;
export type EndShiftForEmployeeMutationOptions = Apollo.BaseMutationOptions<EndShiftForEmployeeMutation, EndShiftForEmployeeMutationVariables>;